import { useQuery } from "@tanstack/react-query";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import {
	ArchivedFilterEnum,
	getPortfolioReportingOverviewV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useReportingQuery = () => {
	return useQuery({
		queryKey: FinanceKeys.reporting(),
		queryFn: processResponse(() =>
			// TODO: expose the archived filter in the UI instead of hardcoding All
			getPortfolioReportingOverviewV2(
				undefined,
				undefined,
				ArchivedFilterEnum.All,
			),
		),
	});
};
